import { useEffect, useState } from "react";

const QUERY = "(max-width: 768px)";

const isNativeApp = () => {
  try {
    return !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
  } catch {
    return false;
  }
};

// For trying the phone layout in a desktop browser: add ?ui=mobile (or
// ?ui=desktop) to the address. Not remembered, so a refresh without it goes back to auto.
const forcedUi = () => new URLSearchParams(window.location.search).get("ui");

const decide = () => {
  const forced = forcedUi();
  if (forced === "mobile") return true;
  if (forced === "desktop") return false;
  return isNativeApp() || window.matchMedia(QUERY).matches;
};

export const useIsMobile = () => {
  const [mobile, setMobile] = useState(decide);

  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const onChange = () => setMobile(decide());
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return mobile;
};
